module.exports = __webpack_public_path__ + "img/cover-2.496f41f2.jpg";